// extracted by mini-css-extract-plugin
module.exports = {"GrantCard":"GrantCard_GrantCard__1AJRT","Name":"GrantCard_Name__7DPuA","Detail":"GrantCard_Detail__38klI","Label":"GrantCard_Label__37oFD"};